module.exports = __webpack_public_path__ + "static/img/act-steps-m-2.bae0158.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/act-steps-m-2.png
// module id = LBm1
// module chunks = 1